import React from 'react';
import { FormGroup, InputGroup, Input, Row, Col } from 'reactstrap';
import { SmallFormFeedback } from '../../../../utils/budget-tool-specific';
import { RebelColors } from '../../../../styles/rebel-experiences';
import styled from 'styled-components';

const RebelFormInputTripLength = (props) => {

    const handleTripLength = (value, type) => {
        const newData = {...props.data};

        if (type === "nights") {
            newData[props.id].value = value;
        }
        if (type === "days") {
            newData[props.id].value = value-1;
        }

        // Update meal counts based on trip length (nights)
        const nights = newData[props.id].value;
        if (newData.numBreakfast !== undefined) {
            newData.numBreakfast.value = nights;
        }
        if (newData.numDinner !== undefined) {
            newData.numDinner.value = nights;
        }
        if (newData.numLunch !== undefined) {
            newData.numLunch.value = Math.max(0, nights - 1);
        }
        if (newData.numAlcohol !== undefined) {
            newData.numAlcohol.value = nights;
        }

        props.setData(newData);
    }


    return (
        <React.Fragment>
            <FormGroup>
                <RebelLabel>Trip Length</RebelLabel>
                <Row>
                    <Col>
                        <InputGroup>
                            <RebelInput placeholder=""
                                            invalid={props.data[props.id].invalid}
                                            type={props.type}
                                            value={props.data[props.id].value * 1 + 1}
                                            onChange={e => handleTripLength(parseInt(e.target.value), "days")} />
                            <RebelInputGroupText>
                            days
                            </RebelInputGroupText>
                        </InputGroup>
                    </Col>
                    <Col>
                        <InputGroup>
                            <RebelInput placeholder=""
                                            invalid={props.data[props.id].invalid}
                                            type={props.type}
                                            value={props.data[props.id].value * 1}
                                            onChange={e => handleTripLength(parseInt(e.target.value), "nights")} />
                            <RebelInputGroupText>
                            nights
                            </RebelInputGroupText>
                        </InputGroup>
                    </Col>
                </Row>
                <RebelFormFeedback>Required</RebelFormFeedback>
            </FormGroup>
        </React.Fragment>
    )
}

export default RebelFormInputTripLength;

const RebelLabel = styled.label`
    color: ${RebelColors.primary};
    font-weight: 500;
    margin-bottom: 8px;
    font-size: 0.95rem;
    display: block;
`;

const RebelInput = styled(Input)`
    font-size: ${props => props.fontSize ? props.fontSize : "16px"};
    margin: ${props => props.fontSize === "16px" ? "" : "0px 0px"};
    border: 1px solid ${RebelColors.border};
    border-radius: 6px !important;
    background-color: #3b3f45;
    color: ${RebelColors.primary};
    padding: 10px 12px;
    min-height: 46px;
    transition: all 0.3s ease;
    width: 60px;
    text-align: center;

    &:focus {
        background-color: #424752;
        border-color: ${RebelColors.gold};
        box-shadow: 0 0 0 3px rgba(255, 215, 0, 0.1);
        color: ${RebelColors.primary};
        outline: none;
    }

    &::placeholder {
        color: ${RebelColors.primaryMuted};
    }

    &:hover {
        border-color: ${RebelColors.borderLight};
        background-color: #424752;
    }
`;

const RebelInputGroupText = styled.span`
    background-color: #2a2e34;
    border: 1px solid ${RebelColors.border};
    color: ${RebelColors.primary};
    border-radius: 6px !important;
    padding: 10px 12px;
    min-height: 46px;
    display: flex;
    align-items: center;
    margin-left: -1px;
    font-size: 0.9rem;
`;

const RebelFormFeedback = styled(SmallFormFeedback)`
    color: ${RebelColors.danger};
`;
